import './oiButton.css';
import React from 'react'

const oiButton = (props) => {
    return (
        <input
            type="button"
            id="oi-button"
            value={props.value}
            onClick={props.clickEvent}
            disabled={props.isDisabled}
        />
    );
};

export default oiButton;


// WEBPACK FOOTER //
// ./src/components/oiButton/oiButton.js